import { Component, Input } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';

@Component({
    selector: 'app-advance-options',
    templateUrl: './advance-options.component.html',
    styleUrls: ['./advance-options.component.scss'],
})
export class AdvanceOptionsComponent {
    @Input() form: UntypedFormGroup;
    tooltip_position = 'above';
}
